module.exports = __webpack_public_path__ + "img/methoden_960.ad495b6a.webp";